import { useEffect, useState } from "react";
import SuiteApi from "../../../api/SuiteApi";
import { EInstrumentType } from "../../../Model/ModuleState";
import SettingsStorageRi360 from "./SettingsStorageRi360";
import SettingsStorageRi1000 from "./SettingsStorageRi1000";
import React from "react";
import { InstrumentInfo } from "../../../Model/InstrumentInfo";

export default function SettingStorage() {
  const [instrumentType, setInstrumentType] = useState(EInstrumentType.Unknown);

  useEffect(() => {
    const getInstrumentType = async () => {
      let result = await SuiteApi.getCurrentInstrumentType();
      setInstrumentType(result);
    };

    getInstrumentType();
  }, []);

  return (
    <div style={{ height: "100%" }}>
      {instrumentType === EInstrumentType.RI360 && <SettingsStorageRi360 />}
      {instrumentType === EInstrumentType.RI1000 && <SettingsStorageRi1000 />}
    </div>
  );
}
